<template>
  <div>
    <form class="form-inline margin-bottom">
      <query-search v-model="querySearch" />
      <limit-buttons-group
        v-model="perPage"
        :count="queriesFiltered(querySearch).length"
        :limits="[10, 25, 50, 100]"
        @update:value="currentPage = 1"
      />
    </form>

    <div class="margin-bottom">
      <table
        v-if="projectMoneyQueries.length"
        class="table"
      >
        <thead>
          <tr class="active">
            <th>
              Запрос
              <div
                v-if="canScroll(getPeriodDates(sengine).length)"
                :class="{ 'text-muted': !canScrollLeft}"
                style="float: right"
                :style="[canScrollLeft ? { cursor: 'pointer' } : {}]"
                @click="offsetLeft()"
              >
                <i class="glyphicon glyphicon-triangle-left" />
              </div>
            </th>
            <th
              v-for="date in slice(getPeriodDates(sengine))"
              :key="date"
            >
              {{ date | moment('DD.MM') }}
            </th>
            <th>
              <i
                v-if="canScroll(getPeriodDates(sengine).length)"
                :class="{ 'text-muted': !canScrollRight(getPeriodDates(sengine).length)}"
                class="glyphicon glyphicon-triangle-right"
                :style="[canScrollRight(getPeriodDates(sengine).length) ? { cursor: 'pointer' } : {}]"
                @click="offsetRight(getPeriodDates(sengine).length)"
              />
            </th>
            <th>Итого:</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="query of queriesFilteredAndPaginated(querySearch, currentPage, perPage)"
            :key="query.id"
          >
            <td>{{ query.txt }}</td>
            <th
              v-for="date in slice(getPeriodDates(sengine))"
              :key="date"
            >
              {{ round(getQueryMoneyValue(query.id, sengine, date)) }}
            </th>
            <th />
            <th class="text-success">
              {{ round(getQueryTotalValue(query.id, sengine), 1) }}
            </th>
          </tr>
        </tbody>
      </table>
      <no-data v-else />
    </div>

    <div class="margin-bottom">
      <c-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total="queriesFiltered(querySearch).length"
      />
    </div>
  </div>
</template>

<script>
import QuerySearch from '../QuerySearch'
import LimitButtonsGroup from '../../../../../../../resources/js/components/LimitButtonsGroup'
import CPagination from '../../../../../../../resources/js/components/ui/CPagination'
import { mapGetters, mapState } from 'vuex'
import tableScrollable from '../../../../../../../resources/js/mixins/tableScrollable'
import helper from '../../../../../../../resources/js/mixins/helper'
import NoData from '../../../../../../../resources/js/components/NoData'

const CURRENT_PAGE_DEFAULT = 1

/**
 * Таблица отчета по деньгам.
 */
export default {
  name: 'MoneyTable',
  components: {
    QuerySearch,
    LimitButtonsGroup,
    CPagination,
    NoData
  },
  mixins: [tableScrollable, helper],
  data () {
    return {
      querySearch: '',
      perPage: 10,
      currentPage: CURRENT_PAGE_DEFAULT
    }
  },
  computed: {
    ...mapState({
      sengine: state => state.seo.positionsFilter.sengine,
      projectMoneyQueries: state => state.seo.project.money.queries
    }),
    ...mapGetters({
      getPeriodDates: 'seo/project/money/getPeriodDates',
      queriesFiltered: 'seo/project/money/queriesFiltered',
      queriesFilteredAndPaginated: 'seo/project/money/queriesFilteredAndPaginated',
      getQueryMoneyValue: 'seo/project/money/getQueryMoneyValue',
      getQueryTotalValue: 'seo/project/money/getQueryTotalValue'
    })
  },
  mounted () {
    this.$root.$on('projectMoneyLoaded', () => {
      this.currentPage = CURRENT_PAGE_DEFAULT
      this.resetScrollOffset()
    })
  }
}
</script>
